// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../action-list';
import {getClaimSearchResults} from '../../shared/repositories';
import {readExcelLayouts} from '../../../shared/action-creators/read-excel-layouts';

export const updateListFilterBy = filterBy => ({
    payload: filterBy,
    property: 'filterBy',
    type: actions.UPDATE_CLAIM_SEARCH_FILTER_BY
});

export const updateListSortBy = sortBy => ({
    payload: sortBy,
    property: 'sortBy',
    type: actions.UPDATE_CLAIM_SEARCH_SORT_BY
});

export const updateListSortDirection = sortDirection => ({
    payload: sortDirection,
    property: 'sortDirection',
    type: actions.UPDATE_CLAIM_SEARCH_SORT_DIRECTION
});

export const updateSearchResults = (query, searchBy) =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const searchResults = await getClaimSearchResults(query, searchBy);

            dispatch({
                data: searchResults,
                type: actions.UPDATE_CLAIM_SEARCH_RESULTS_SUCCESS
            });

            if (searchResults.length) {

                const dateRange = {
                    from: Math.min(...searchResults.map(searchResult => searchResult.recordInfo.createdDate)),
                    to: Math.max(...searchResults.map(searchResult => searchResult.recordInfo.createdDate))
                };

                dispatch({
                    dateRange,
                    type: actions.UPDATE_CLAIM_DATE_RANGE_FACET
                });

            }

            dispatch({
                data: searchResults,
                type: actions.FILTER_CLAIM_SEARCH_RESULTS
            });

            dispatch({
                hasSearchResults: true,
                type: actions.UPDATE_CLAIM_HAS_SEARCH_RESULTS
            });

            if (!getState().exportToExcel.selectedExcelLayout.claims.name) {

                readExcelLayouts('claims')(dispatch);

            }

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/claim-search/action-creators/claim-search.js